export const yesNoTFOptions = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
]

export const fullPartTimeOptions = [
  { value: "Full-time", label: "Full-time" },
  { value: "Part-time", label: "Part-time" },
]
